import React, { Suspense, useState, useEffect } from "react";
import { Modal } from 'react-responsive-modal';
import ClientProfileServices from "../clientProfileServices";
import Pagination from "components/Common/newPagination";

export default function SearchTerritory(param: any) {

    let [territoryValue, setTerritoryValue] = useState("");
    let [territoryData, setTerritoryData] = useState<any>([]);
    let [territoryDataTemp, setTerritoryDataTemp] = useState<any>([]);
    let [selectedTerritoryName, setSelectedTerritoryName] = useState("");

    useEffect(() => {
        if (param.selectedTerritory) { setSelectedTerritoryName(param.selectedTerritory); }

    }, [param]);

    var pagination = { pageNumber: 1, pageSize: 10 }

    const searchTerritories = () => {
        ClientProfileServices.getTerritory(territoryValue).then(response => {
            territoryData = response?.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
            setTerritoryData(territoryData)
            setTerritoryDataTemp(response);

        })
    }

    const onSelectTerritory = (post: any) => { param.onSelectTerritory(post); }

    const closeTerritoryDetail = () => { param.closeTerritoryDetail() }

    const territoryPagination = (e: any) => {
        pagination.pageNumber = e.pageNumber
        pagination.pageSize = e.pageSize
        territoryData = territoryDataTemp?.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
        setTerritoryData(territoryData)
    }

    return (
        <div className='pull-left' >
            <Modal open={param.open} onClose={closeTerritoryDetail} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-7 paddingCenterBox bgTransparent' }} >
                <div className="ws-12 box">
                    <div className="ws-12">
                        <div className="box-header-main well">  <h2>Search Territory</h2> </div>

                        <div className="box-content">
                            <div className="form-horizontal  form-condensed clearfix">
                                <div className="row-fluid ws-10">

                                    <div className="ws-5">
                                        <div className="control-group">
                                            <label className="control-label text-bold">Territory Code/Currency/Name</label>
                                            <div className="controls">
                                                <input type="text" className="ws-12 form-control" placeholder="Enter Territory Code/Currency/Name"
                                                    value={territoryValue} onChange={(e) => setTerritoryValue(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ws-3 mt">
                                        <a className="btn btn-small icon-btn edit mtl" onClick={searchTerritories}><i className="fa fa-search"></i>Search </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="ws-12">
                        <div className="box span12">
                            <div className="box-header well">
                                <h2> <i className="fa fa-table"></i> <span> </span>  </h2>
                            </div>
                            <div className="box-content">
                                {territoryData.length === 0 ? (<div className="alert alert-info">No records to display</div>
                                ) : (

                                    <div className="table-responsive">
                                        <table className="newTable">
                                            <thead>
                                                <tr>
                                                    <th>Territory Name</th>
                                                    <th>Territory Code</th>
                                                    <th>Territory Currency</th>
                                                    <th>Operation</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {territoryData.map((post: any, index: any) => (
                                                    <tr key={index}>
                                                        <td>{post.territoryName}</td>
                                                        <td>{post.territoryCode}</td>
                                                        <td>{post.territoryCurrency}</td>
                                                        <td>
                                                            <a className="icon-btn info" onClick={() => { onSelectTerritory(post); setSelectedTerritoryName(post.territoryName); }}>
                                                                <i className="icon-th icon-white"></i>Select
                                                            </a>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>)

                                }

                                <div className="clearfix">
                                    {
                                        (() => {
                                            if (territoryDataTemp.length > 10) {
                                                return <Pagination onPageChange={territoryPagination} totalRow={territoryDataTemp.length} />
                                            }
                                        })()
                                    }
                                </div>
                            </div>

                        </div>

                    </div>

                </div>

            </Modal>
        </div>
    );
}